import React, { FC } from 'react'
import { getValueListTextColor } from '../../../utils/background-util'
import { BrandIcon } from '../../Compounds/src/BrandIconCompound'

interface Props {
  milestoneColor: string
  contentDesc: string
  milestoneMonthDesc: string
  leftAligned: boolean
  icon: any
  image: any
}

export const RowComponent: FC<Props> = props => {
  const { milestoneColor, contentDesc, milestoneMonthDesc, leftAligned, icon, image } = props
  const size = icon && icon?.size?.length > 0 ? icon?.size : 'large'
  const labelColor = milestoneColor?.length > 0 ? milestoneColor : 'midnight-blue'

  return (
    <div
      className={`Journey u-flex u-posRelative ${
        leftAligned
          ? 'Journey-left u-sm-flexJustifyStart u-md-flexJustifyStart u-lg-after6of12'
          : 'Journey-right u-lg-before6of12'
      }`}>
      <h3
        className={`Journey-step step-right u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull ${
          leftAligned ? 'step-left' : 'right-aligned'
        } ${getValueListTextColor(labelColor)}`}>
        {milestoneMonthDesc}
      </h3>
      <div
        className={`Journey-content u-md-size10of12 u-flex u-flexJustifyBetween u-paddingVert4gu u-sm-paddingLeft2gu u-posRelative u-size9of12 ${
          leftAligned
            ? 'left-aligned u-md-paddingRight0 u-paddingRight6gu u-sm-paddingRight0 u-md-paddingLeft6gu'
            : 'right-aligned step-right u-paddingLeft6gu u-paddingLeft6gu'
        }`}>
        {leftAligned && (
          <div className='Journey-image u-sm-hidden u-md-hidden'>
            <BrandIcon {...icon} size={size} />
            {icon?.iconsDropdown?.length === 0 && <img src={image.imageUrl} alt={image.imageAlt} />}
          </div>
        )}
        <div
          className='Journey-text u-size10of12'
          dangerouslySetInnerHTML={{ __html: contentDesc }}
        />

        <div className={`Journey-image ${leftAligned ? 'u-lg-hidden' : 'right-aligned'}`}>
          <BrandIcon {...icon} size={size} />
          {icon?.iconsDropdown?.length === 0 && <img src={image.imageUrl} alt={image.imageAlt} />}
        </div>
      </div>
    </div>
  )
}
